export const getInstIdentifierKey = (id: string, source: string) => {
  const idLength = id.length;
  const sourceLength = source.length;
  return idLength + id + sourceLength + source;
};
